/* unplugin-vue-components disabled */import { render } from "./CommunityEasyCard.vue?vue&type=template&id=2de1f0f0"
import script from "./CommunityEasyCard.vue?vue&type=script&lang=js"
export * from "./CommunityEasyCard.vue?vue&type=script&lang=js"

import "./CommunityEasyCard.vue?vue&type=style&index=0&id=2de1f0f0&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__